export const timesheetTypes = {
  'clocking': 'Timbrature',
  'precompiled_employee': 'Precompilato dipendente',
  'precompiled_company': 'Precompilato azienda',
  'precompiled_company_clocking': 'Precompilato azienda + Timbrature',
  'precompiled_employee_clocking': 'Precompilato dipendente + Timbrature',
  'presence_clocking': 'Presenza da timbrature',
  'manual': 'Manuale',
}

export const CLOCKING_DRIVEN_TIMESHEET_TYPES = ['clocking', 'presence_clocking'];

export const TIMESHEET_TYPES_WITH_CLOCKINGS = [
  ...CLOCKING_DRIVEN_TIMESHEET_TYPES,
  'precompiled_company_clocking',
  'precompiled_employee_clocking',
];

export const hasClockingDrivenTimesheet = (type) => CLOCKING_DRIVEN_TIMESHEET_TYPES.includes(type);
export const hasTimesheetClockings = (type) => TIMESHEET_TYPES_WITH_CLOCKINGS.includes(type);

// Anomalie su giorni con le ore a posto (es. timbratura in ferie o in festività): non risultano dalle ore mancanti.
// L'azienda le può segnare come verificate quando il dato è corretto. Allineata all'API (timesheet-types.ts).
export const VERIFIABLE_ANOMALY_CODES = ['presence_on_absence_day', 'festivity_worked_timesheet'];

export const pendingDayAnomalies = (anomalies, day) =>
  (anomalies || []).filter((a) => a.day === day && VERIFIABLE_ANOMALY_CODES.includes(a.anomaly_code) && !a.verified_at);

export const resolveTimesheetType = (employeeType, companyType) => employeeType || companyType || null;
